import { I as x } from "../IdController-Cpj_A6H5.js";
import { P as $ } from "../pwc-interactive-element-B6286Ky3.js";
import { x as c, c as k } from "../lit-element-8JrrHldg.js";
import { P as l } from "../pwc-component-size.enum-ldIKEMHl.js";
import { p as o } from "../pwcProperty-CTLG9yrF.js";
import { w as _ } from "../watch-ChG-_stu.js";
import "../warning-hex-filled-CZflkO7j.js";
import { c as f } from "../clsx-DB4S2d7J.js";
import { n as u } from "../property-4FoNj0Pi.js";
import { r as y } from "../state-D4BCZ2JK.js";
import { o as w } from "../if-defined-Cd-e8xtV.js";
import { n as P } from "../ref-ArR26hg7.js";
let L = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M6.5 12.102 2 7.602l.707-.707L6.5 10.688l6.793-6.793.707.707-7.5 7.5Z"></path></svg>';
  }
};
const b = "pi-checkmark";
customElements.get(b) || customElements.define(b, L);
class M extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M12 7.5H4v1h8v-1Z"></path></svg>';
  }
}
const g = "pi-minus";
customElements.get(g) || customElements.define(g, M);
var E = Object.defineProperty, S = Object.getOwnPropertyDescriptor, s = (e, t, r, a) => {
  for (var n = a > 1 ? void 0 : a ? S(t, r) : t, d = e.length - 1, p; d >= 0; d--)
    (p = e[d]) && (n = (a ? p(t, r, n) : p(n)) || n);
  return a && n && E(t, r, n), n;
}, z = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, B = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, v = (e, t, r) => (z(e, t, "access private method"), r), h, m;
const C = "pwc-checkbox";
let i = class extends $ {
  constructor() {
    super(...arguments), B(this, h), this.slotControlled = ["default", "description"], this._labelled = !1, this.idController = new x(this, {
      base: "PwcCheckbox",
      children: ["input"]
    }), this.getIcon = () => {
      let e = "3", t = "12";
      return this.size === l.Small && (e = "2", t = "10"), this.size === l.Large && (e = "4", t = "14"), this.indeterminate ? c`<svg
        class="PwcCheckbox__indeterminate-icon"
        height=${e}
        width=${t}
        viewBox="0 0 12 4"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.5" width="12" height="3" />
      </svg>` : (e = "10", t = "12", this.size === l.Small && (e = "8", t = "10"), this.size === l.Large && (e = "12", t = "14"), this.checked ? c`<svg
        class="PwcCheckbox__checked-icon"
        height=${e}
        width=${t}
        viewBox="0 0 12 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1.98589L4.09561 10L0 5.84753L1.9587 3.86164L4.09561 6.02823L10.0413 0L12 1.98589Z"
        />
      </svg>` : "");
    }, this.getAriaChecked = () => this.checked ? !0 : this.indeterminate ? "mixed" : !1;
  }
  handleLabelChange() {
    var e;
    this._labelled = !!this.label && ((e = this.label) == null ? void 0 : e.length) > 0;
  }
  handleLabelledChange() {
    this._labelled = this.labelled;
  }
  render() {
    const {
      idController: {
        id: e,
        child: { input: t }
      }
    } = this, r = () => ({
      PwcCheckbox: !0,
      "PwcCheckbox--checked": this.checked,
      "PwcCheckbox--disabled": this.disabled,
      "PwcCheckbox--error": this.error,
      "PwcCheckbox--readonly": this.readonly,
      "PwcCheckbox--indeterminate": this.indeterminate,
      "PwcCheckbox--sm": this.size === l.Small,
      "PwcCheckbox--md": this.size === l.Medium,
      "PwcCheckbox--lg": this.size === l.Large
    }), a = () => c`
      <input
        ${P(this.interactiveElementRef)}
        class="PwcCheckbox__input"
        type="checkbox"
        title=${this.title}
        name=${this.name}
        id=${t}
        value=${w(this.value)}
        .indeterminate=${this.indeterminate}
        ?checked=${this.checked}
        ?disabled=${this.disabled}
        ?required=${this.required}
        ?readonly=${this.readonly}
        tabindex=${w(this.tabIndex)}
        ?aria-disabled=${this.disabled}
        ?aria-readonly=${this.readonly}
        aria-selected=${this.getAriaChecked()}
        role="checkbox"
        @change=${v(this, h, m)}
      />
      <span
        class="PwcCheckbox__control"
        @click=${() => this._labelled ? null : v(this, h, m).call(this)}
      >
        ${this.getIcon()}
      </span>
    `;
    return this._labelled ? c`<div class=${f(r())}>
          <label id="${e}" for="${t}">
            <div class="PwcCheckbox__label__elements">
              <div class="PwcCheckbox__control__container">${a()}</div>

              <div class="PwcCheckbox__text__label">
                <p-slot .host=${this}></p-slot>
                ${!this.slotted.default && this.label || ""}
                ${this.required ? c`&nbsp;*` : null}
              </div>
            </div>
          </label>

          <div class="PwcCheckbox__text__description">
            <p-slot .host=${this} name="description"></p-slot>
            ${!this.slotted.description && this.description || ""}
          </div>
        </div>

        ${this.error && this.errorMessages ? c`<pwc-input-message
              .errorMessages=${this.errorMessages}
            ></pwc-input-message>` : null}` : c`
      <div id=${e} class=${f(r())}>${a()}</div>
    `;
  }
};
h = /* @__PURE__ */ new WeakSet();
m = function() {
  this.disabled || this.readonly || (this.checked = !this.checked, this.emit("p-change", { detail: this.checked }), this.indeterminate = !1);
};
i.tagName = C;
s([
  o({ type: Boolean, reflect: !0, default: !1 })
], i.prototype, "checked", 2);
s([
  o({ type: Boolean, reflect: !0, default: !1 })
], i.prototype, "indeterminate", 2);
s([
  o({ default: l.Medium })
], i.prototype, "size", 2);
s([
  o({ type: Boolean, reflect: !0, default: !1 })
], i.prototype, "disabled", 2);
s([
  o({ type: Boolean, reflect: !0, default: !1 })
], i.prototype, "required", 2);
s([
  u({ type: String })
], i.prototype, "label", 2);
s([
  o({ type: Boolean, default: !1 })
], i.prototype, "labelled", 2);
s([
  u({ type: String })
], i.prototype, "description", 2);
s([
  o({ type: String, default: "" })
], i.prototype, "title", 2);
s([
  o({ type: String, default: "" })
], i.prototype, "name", 2);
s([
  u()
], i.prototype, "value", 2);
s([
  y()
], i.prototype, "_labelled", 2);
s([
  _("label")
], i.prototype, "handleLabelChange", 1);
s([
  _("labelled")
], i.prototype, "handleLabelledChange", 1);
i = s([
  k(C)
], i);
export {
  i as PwcCheckbox
};
